import { Component, HostListener } from '@angular/core';

export interface Work {
  img: string;
  title: string;
  category: string;
}

@Component({
  selector: 'app-portfolio-three-column',
  templateUrl: './portfolio-two.component.html',
  styleUrl: './portfolio-two.component.css'
})
export class PortfolioThreeColumnComponent {
  // Video Popup
  isOpen = false;
  openPopup(): void {
      this.isOpen = true;
  }
  closePopup(): void {
      this.isOpen = false;
  }

  // Gallery Properties
  currentGalleryIndex = 0;
  showGalleryModal = false;
  
  // Gallery Items
  galleryItems = [
    {
      src: 'assets/images/portfolio/gallery-14.jpg',
      title: 'Gallery Image 1'
    },
    {
      src: 'assets/images/portfolio/gallery-15.jpg',
      title: 'Gallery Image 2'
    },
    {
      src: 'assets/images/portfolio/gallery-16.jpg',
      title: 'Gallery Image 3'
    },
    {
      src: 'assets/images/portfolio/gallery-17.jpg',
      title: 'Gallery Image 4'
    },
    {
      src: 'assets/images/portfolio/gallery-18.jpg',
      title: 'Gallery Image 5'
    },
    {
      src: 'assets/images/portfolio/gallery-19.jpg',
      title: 'Gallery Image 6'
    }
  ];  

  openGallery(index: number): void {
    this.currentGalleryIndex = index;
    this.showGalleryModal = true;
  }

  closeGallery(): void {
    this.showGalleryModal = false;
  }

  nextGalleryImage(): void {
    if (this.currentGalleryIndex < this.galleryItems.length - 1) {
      this.currentGalleryIndex++;
    } else {
      this.currentGalleryIndex = 0;
    }
  }

  previousGalleryImage(): void {
    if (this.currentGalleryIndex > 0) {
      this.currentGalleryIndex--;
    } else {
      this.currentGalleryIndex = this.galleryItems.length - 1;
    }
  }

  @HostListener('document:keydown.escape')
    onEscapeKey(): void {
      this.closeGallery();
  }
  
}
